import FooterBlock from '@/blocks/FooterBlock';
import HeaderBlock from '@/blocks/HeaderBlock';
import { SITE_TITLE } from '@/constants/env';
import Head from 'next/head';

export default function FullWidthLayout({ children, mainLayout, metaData }) {
  const siteTitle = metaData.metaTitle ? `${metaData.metaTitle} - ${SITE_TITLE}` : SITE_TITLE;
  return (
    <>
      <Head>
        <title>{siteTitle}</title>
        <meta content={siteTitle} name="title" />
        <meta content={siteTitle} property="og:title" />
        <meta content={siteTitle} property="twitter:title" />
      </Head>
      <HeaderBlock navBar={mainLayout.attributes.navBar} />
      <main className="mt-20 lg:mt-28">{children}</main>
      <FooterBlock footer={mainLayout.attributes.footer} />
    </>
  );
}
